
import KitTemplatePage from 'components/distributionSetting/kitTemplate'
import CommonLayout from 'layouts/DashboardLayout'
import RefillTemplatePage from 'components/distributionSetting/kitTemplate/RefillTemplatePage'
import React from 'react'

const KitTemplate = () => {
    return (
        <CommonLayout>
            <KitTemplatePage />
            <RefillTemplatePage />
        </CommonLayout>
    )
}

export default KitTemplate
